module.exports = __webpack_public_path__ + "static/281-402df339bb6fa8e4b2e7708c23b2bfff.png";